import { render, staticRenderFns } from "./AdminSaldos.vue?vue&type=template&id=07efb469&"
import script from "./AdminSaldos.vue?vue&type=script&lang=js&"
export * from "./AdminSaldos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports